import './index.scss';
import 'plyr/dist/plyr.css';
import Hls from 'hls.js';
import Plyr from 'plyr';
import { EventManager } from 'utils/event_manager';
import { updateFreemiumCounter } from 'utils/freemium';

const TIME_VIDEO_TOTAL = 10; // seconds

(function () {
  'use strict';

  const hlsInstances = new Map();
  const playerInstances = new Map();

  function destroyHlsInstance(videoElement) {
    const hls = hlsInstances.get(videoElement);

    if (hls) {
      hls.destroy();
      hlsInstances.delete(videoElement);
    }
  }

  function destroyPlayerInstance(videoElement) {
    const player = playerInstances.get(videoElement);

    if (player) {
      player.destroy();
      playerInstances.delete(videoElement);
    }
  }

  function pauseVideo(element) {
    try {
      if (typeof element.pause === 'function') {
        element.pause();
      }
    } catch (ex) {
      Rollbar.error('Pause function not found or supported', ex);
    }
  }

  function pauseVideos(current) {
    const $current = $(current);

    if (!$current.hasClass('js-video-player')) {
      return;
    }

    $('.js-video-player')
      .not($current)
      .each((i, el) => pauseVideo(el));
  }

  function emitEvent(current) {
    const $current = $(current).find('video');
    const { eventEmitted, disciplineName, resourceType, previewVideo } =
      $current.data();

    if (eventEmitted || previewVideo) {
      return;
    }

    UserTracker.emit('event', {
      eventName: 'lesson played',
      data: {
        discipline: disciplineName,
        'lesson type': 'gravada'
      }
    });

    $current.data('eventEmitted', true);

    if (gon.flags.freemium_lessons && resourceType === 'lessons') {
      const $lesson = $current.closest('.q-track-video');
      $lesson.addClass('lesson-opened');

      updateFreemiumCounter('lessons');
    }

    if (resourceType === 'question_teacher') {
      const $teacher = $current.closest('.q-question-teacher');
      $teacher.addClass('teacher-opened');

      updateFreemiumCounter('teachers');
    }
  }

  function handleRateChange() {
    const videoPlaybackRate = this.playbackRate || 1;

    if (localStorage) {
      localStorage.setItem('videoPlaybackRate', videoPlaybackRate);
    }
  }

  function setPlaybackSpeedRate(current) {
    if (localStorage) {
      const localStorageSpeedRate = Number(
        localStorage.getItem('videoPlaybackRate')
      );

      if (localStorageSpeedRate) {
        current.playbackRate = localStorageSpeedRate;
      }
    }
  }

  function setupLocalStorageConfig(current) {
    setPlaybackSpeedRate(current);
  }

  function handleVideoPlay() {
    const currentVideo = this;

    pauseVideos(currentVideo);
    emitEvent(currentVideo);
    setupLocalStorageConfig(currentVideo);
  }

  function handleTimeUpdate() {
    const currentVideo = this;
    const $currentVideo = $(currentVideo);
    const { time } = $currentVideo.data();

    $currentVideo.css('pointer-events', 'none');
    const timeTo = time || TIME_VIDEO_TOTAL;

    if (parseInt(currentVideo.currentTime) >= parseInt(timeTo)) {
      pauseVideo(currentVideo);
      $currentVideo.prev().removeAttr('style').end().remove();
    }
  }

  function handleVideoEnded() {
    const currentVideo = this;

    UserTracker.emit('event', {
      eventName: 'lesson completed',
      data: {
        'video duration': currentVideo.duration || 0
      }
    });
  }

  function updateQuality(quality, hls) {
    const index = hls.levels.findIndex(level => level.height === quality);
    hls.currentLevel = index;
  }

  function setupPlyr(videoElement, options = {}) {
    const controls = [
      'play-large',
      'restart',
      'rewind',
      'play',
      'fast-forward',
      'progress',
      'current-time',
      'duration',
      'mute',
      'volume',
      'settings',
      'pip',
      'airplay',
      'fullscreen'
    ];

    const i18n = {
      speed: 'Velocidade',
      quality: 'Qualidade'
    };

    const player = new Plyr(videoElement, {
      controls,
      i18n,
      ...options
    });

    player.on('play', handleVideoPlay);
    player.on('ended', handleVideoEnded);
    player.on('canplay', () => {
      if (player.config.speed?.selected) {
        player.speed = player.config.speed.selected;
      }
    });

    // Handle preview video time limit
    const $videoElement = $(videoElement);
    const { previewVideo } = $videoElement.data();

    if (previewVideo) {
      player.on('timeupdate', handleTimeUpdate);
    }

    playerInstances.set(videoElement, player);
  }

  function bindVideoEvents($videoElement) {
    const videoElement = $videoElement[0];
    const src = $videoElement.attr('src');

    destroyHlsInstance(videoElement);
    destroyPlayerInstance(videoElement);

    // HLS nativo primeiro, MSE depois. No iOS todo browser e WebKit, e do
    // iOS 17.1 em diante o hls.js enxerga `ManagedMediaSource` e responde
    // `isSupported() === true` — o que fazia este ramo nativo virar codigo
    // morto em iPhone/iPad. Como o belt monta ate 5 aulas de uma vez
    // (`first_five_lessons`), o resultado eram 5 MediaSource concorrentes: o
    // WebKit so entregava pipeline de midia para parte delas, as demais nunca
    // chegavam em MANIFEST_PARSED e, como o <video> nao declara `controls`,
    // ficavam so com o poster e nada clicavel (PROD3-370).
    if (videoElement.canPlayType('application/vnd.apple.mpegurl')) {
      videoElement.src = src;
      setupPlyr(videoElement);
    } else if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(src);
      hls.attachMedia(videoElement);
      hlsInstances.set(videoElement, hls);

      hls.on(Hls.Events.MANIFEST_PARSED, (_event, data) => {
        const availableQualities = data.levels.map(l => l.height);

        const quality = {
          default: availableQualities[0],
          options: availableQualities,
          forced: true,
          onChange: e => updateQuality(e, hls)
        };

        setupPlyr(videoElement, { quality });
      });
    } else {
      setupPlyr(videoElement);
    }

    $videoElement.on('ratechange', handleRateChange);
  }

  function bindVideoPlayers() {
    $('.js-video-player').each((i, videoElement) => {
      const $videoElement = $(videoElement);
      bindVideoEvents($videoElement);
    });
  }

  function bind() {
    $(document)
      .off('hide.bs.collapse.video-player')
      .on('hide.bs.collapse.video-player', '.collapse', function () {
        $('.js-video-player', this).each((i, el) => {
          pauseVideo(el);
        });
      });

    // eslint-disable-next-line no-undef
    EventManager.subscribe('questionBelt.tabClosed', (e, data) => {
      $('.js-video-player', data.$tabPane).each((i, el) => {
        pauseVideo(el);
        destroyHlsInstance(el);
        destroyPlayerInstance(el);
      });
    });

    const hasVideoPlayer = $('.js-video-player').length;

    if (hasVideoPlayer) {
      return bindVideoPlayers();
    }

    EventManager.subscribe('questionBelt.tabLoaded', () => {
      bindVideoPlayers();
    });
  }

  bind();
})();
